export enum ETipoDevolucaoPagamento {
  Manter = 1,
  LancarCredito = 2,
  AbaterSaldo = 3,
  LancarContasReceber = 4,
}
